import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { auth } from '../firebase';
import { sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const checkVerification = setInterval(() => {
      if (user) {
        user.reload().then(() => {
          if (user.emailVerified) {
            clearInterval(checkVerification);
            navigate('/dashboard');
          }
        });
      }
    }, 3000);

    return () => clearInterval(checkVerification);
  }, [user, navigate]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleResendVerification = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      alert('Verification email sent! Please check your inbox.');
    } catch (error) {
      alert('Error sending verification email. Please try again later.');
      console.error(error);
    }
  };

  if (!user) {
    navigate('/login');
    return null;
  }

  if (user.emailVerified) {
    navigate('/dashboard');
    return null;
  }

  return (
    <div style={{ 
      padding: '40px',
      textAlign: 'center',
      maxWidth: '600px',
      margin: '50px auto',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      border: '1px solid #e5e7eb'
    }}>
      <div style={{
        fontSize: '64px',
        marginBottom: '20px',
        lineHeight: '1'
      }}>
        ✉️
      </div>
      <h2 style={{
        color: '#2563eb',
        fontSize: '28px',
        marginBottom: '24px',
        fontWeight: '600'
      }}>
        Almost there! 🎉
      </h2>
      <p style={{
        fontSize: '18px',
        color: '#374151',
        marginBottom: '16px',
        lineHeight: '1.6'
      }}>
        We've sent a verification link to <strong>{user?.email}</strong>
      </p>
      <p style={{
        fontSize: '16px',
        color: '#6b7280',
        marginBottom: '24px',
        lineHeight: '1.5'
      }}>
        Please check your inbox and click the verification link to activate your account.
        We'll automatically redirect you once your email is verified! ({countdown}s)
      </p>
      <button
        onClick={handleResendVerification}
        style={{
          backgroundColor: '#2563eb',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '8px',
          border: 'none',
          fontSize: '16px',
          cursor: 'pointer',
          marginTop: '16px',
          fontWeight: '500'
        }}
      >
        Resend Verification Email
      </button>
      <p style={{
        fontSize: '14px',
        color: '#9ca3af',
        marginTop: '24px'
      }}>
        Can't find the email? Check your spam folder or request a new verification link above.
      </p>
    </div>
  );
};

export default VerifyEmail;
